export function isNavItemActive(itemPath, currentPathname) {
  if (itemPath === '/') return currentPathname === '/' || currentPathname.startsWith('/applicants/');
  if (itemPath === '/settings') return currentPathname === '/settings';
  return currentPathname === itemPath || currentPathname.startsWith(`${itemPath}/`);
}
